import React from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { ColorPreview } from "../form/common/ColorPreview";
import { formConfig } from "../form/formConfig";
import { ShapePreview } from "../form/common/ShapePreview";
import { IoMdClose } from "react-icons/io";
import { MdDeleteForever } from "react-icons/md";
import { MdOutlineRemoveShoppingCart } from "react-icons/md";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { NothingHere } from "../form/common/NothingHere";
import { IoMdArrowRoundBack } from "react-icons/io";
import { extra_opmeting_price } from "@myproject/shared";

export const OrderSummary = ({ orders, closeBasket, remove_opmeting, remove_from_card }) => {

  const extra_opmeting = orders.find(o => o.OPMETING);
  return (
    <>

      <button
          onClick={closeBasket}
            type="button"
            className="absolute top-0 right-0 m-4 inline-flex items-center p-3 text-sm font-medium text-center text-white bg-blue-600 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            <IoMdArrowRoundBack className="text-white font-black" />
          </button>


      {/* 
<div className="h-auto bg-red flex justify-start mb-2">
  <div className="flex items-center h-5">
    <input
      type="checkbox"
      id="opmeting"
      className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
    />
  </div>
  <label htmlFor="opmeting" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
    Ik wens de <a href="#" className="text-blue-600 hover:underline dark:text-blue-500">opmeting</a> te laten uitvoeren (+150 euro)
  </label>
</div>
*/}
    <div
      className="p-2 overflow-y-auto	"
    >
      <h1 className="ml-2 my-3 text-4xl font-extrabold text-gray-800 dark:text-white">
        Winkelmandje
      </h1>
          

{orders.length == 0 ? <NothingHere /> : 
<div className="relative overflow-x-auto rounded-lg">
    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th scope="col" className="px-6 py-3">
                Afmetingen<br />(breedte x hoogte)
                </th>
                <th scope="col" className="px-6 py-3">
                Kleur frame
                </th>
                <th scope="col" className="px-6 py-3">
                Type gaas
                </th>
                <th scope="col" className="px-6 py-3">
                Aantal
                </th>
                <th scope="col" className="px-6 py-3">
                Prijs / Stuk
                </th>
                <th scope="col" className="px-6 py-3">
                
                </th>
            </tr>
      
        </thead>
        <tbody>

        {orders.map((order,i) => {
          const option_color = formConfig.find(x => x.name=='FRAME_COLOR').options.find(x => x.code == order.FRAME_COLOR);
          const option_gaas = formConfig.find(x => x.name=='GAAS_TYPE').options.find(x => x.code == order.GAAS_TYPE);
         
         const formattedPrice = new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR',
          maximumFractionDigits: 2
        }).format(order.prijs);

          console.log(option_gaas)

          if(!option_color || !option_gaas) return (<tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"><td className="px-6 py-4">Foutje!</td></tr>)

          return (

            <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th scope="row" className="px-4 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                {order.DIMENSION.WIDTH} mm x {order.DIMENSION.HEIGHT} mm
                </th>
                <td className="px-4 py-4">
                  <ColorPreview color={option_color.color} label={option_color.label} diameter={30} />
                
                </td>
                <td className="px-4 py-4">
                <ShapePreview color={option_gaas.color} diameter={30} label={option_gaas.label} />
                </td>
                <td className="px-4 py-4">
                {order.AANTAL}
                </td>
                <td className="px-4 py-4">
                {formattedPrice}
                </td>

                <td className="px-4 py-4">
                  <div className="flex gap-4">
                  <MdOutlineRemoveShoppingCart onClick={() => remove_from_card(i)} className="text-xl text-orange-400 cursor-pointer" />                  
                  </div>
                </td>
            </tr>
                )})}
          

          {extra_opmeting? 
          <tr key="opmeting" className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th scope="row" className="px-4 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                Extra opmeting
                </th>
                <td className="px-4 py-4">
                  
                </td>
                <td className="px-4 py-4">
                </td>
                <td className="px-4 py-4">
1                </td>
                <td className="px-4 py-4">
                {new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR',
          maximumFractionDigits: 2
        }).format(extra_opmeting_price(orders))
        }
                </td>

                <td className="px-4 py-4">
                  <div className="flex gap-4">
                  <MdOutlineRemoveShoppingCart onClick={() => remove_opmeting()} className="text-xl text-orange-400 cursor-pointer" />                  
                  
                  </div>
                </td>
            </tr> : '' }

                
        </tbody>
    </table>
</div>
}


      </div>



    </>
  );
};
